import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { monitoringKeys } from '@/shared/lib/query/queryKeys';

import { getAvailableWorkers } from '@/features/monitoring/api/prometheusApi';

export const useAvailableWorkers = () => {
  return useQueryWithBoundary({
    queryKey: monitoringKeys.availableWorkers(),
    queryFn: getAvailableWorkers,
    staleTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
